import { getClientFacingMessage } from '@massilia/queries'
import { toast } from 'sonner'

/** Le geste « devis similaire » d'UNE proposition, quelle que soit la mutation derrière. */
export interface SimilarRequest {
  isPending: boolean
  isSuccess: boolean
  send: () => void
}

/**
 * Taille une mutation partagée par plusieurs cartes en un geste par proposition :
 * seule celle qu'on vient de cliquer passe en attente puis en « transmis ».
 */
export function similarRequestFor(
  mutation: {
    isPending: boolean
    isSuccess: boolean
    mutate: (responseId: string, options: { onError: (error: Error) => void }) => void
    variables?: string
  },
  responseId: string
): SimilarRequest {
  const isThis = mutation.variables === responseId
  return {
    isPending: isThis && mutation.isPending,
    isSuccess: isThis && mutation.isSuccess,
    send: () =>
      mutation.mutate(responseId, {
        // Le message du serveur dit pourquoi (déjà réservé ailleurs, encore valable…).
        onError: (error) =>
          toast.error(getClientFacingMessage(error, 'Impossible d’envoyer votre demande')),
      }),
  }
}
